module.exports = __webpack_public_path__ + "img/mend.4fca4119.svg";